module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"new":"Nouveau","inProgress":"En cours","waitingForValidation":"A valider","validated":"Validé","generatedMail":"Courrier généré","closed":"Clôturé","loading":"Chargement..."}}')
  delete Component.options._Ctor
}
